import { NumberInput } from 'react-admin';
import { styled } from '@mui/material/styles';

const StyledNumberInput = styled(NumberInput)`
  width: 100%;
`;

export default StyledNumberInput;
